import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import GetParams from "../../utils/getParams";
import { useTranslation } from "react-i18next";
import { COMMON_WEB_PATH } from "../../constant";

import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

import useDeviceType from "../../hook/useDeviceType";
import LazyImage from "../Loading/lazyImage";
import { useInView } from "react-intersection-observer";

const SupplierList = ({ LIST, setPlatform = () => {}, customNavigate }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const ref = useRef(null);

  const { ref: containerRef, inView } = useInView({
    threshold: 0.75,
    rootMargin: "0px 0px 0px 0px",
  });

  useEffect(() => {
    if (inView) {
      ref.current.splide.Components.AutoScroll.play();
    } else {
      ref.current.splide.Components.AutoScroll.pause();
    }
  }, [inView]);

  const isMobile = useDeviceType() === "Mobile";

  const navigate = useNavigate();

  const currentPlatform = GetParams("platform");

  return (
    <>
      <p className="text-xl font-bold text-base-light-dark dark:text-base-light-white">
        {i18n("supplier")}
      </p>
      <div ref={containerRef}>
        <Splide
          ref={ref}
          extensions={{ AutoScroll }}
          options={{
            type: "loop",
            pagination: false,
            arrows: false,
            drag: "free",
            perPage: 6,
            lazyLoad: "nearby",
            preloadPages: 1,
            breakpoints: {
              1440: {
                perPage: 6,
              },
              1280: {
                perPage: 6,
              },
              768: {
                perPage: 5,
              },
              640: {
                perPage: 2,
              },
            },
            perMove: 1,
            gap: 20,
            dragMinThreshold: {
              mouse: 0,
              touch: 10,
            },
            keyboard: false,
          }}
        >
          {LIST?.map((item, index) => {
            return (
              <SplideSlide key={item}>
                <div
                  onClick={() => {
                    if (customNavigate) {
                      navigate(`${customNavigate}${item}/all`);
                    } else {
                      navigate(`?platform=${item}`);
                    }
                    setPlatform(item);
                  }}
                  className="flex h-[66px] items-center justify-center py-[5px] px-[15px] rounded-lg bg-base-light-white dark:bg-base-light-dark group cursor-pointer transition duration"
                  // className="flex min-w-[150px] md:min-w-[150px] h-[55px] items-center justify-center py-[5px] px-[15px] rounded-lg bg-base-light-white dark:bg-base-light-dark group cursor-pointer  transition duration"
                >
                  <LazyImage
                    className={`w-[100px] h-[55px] object-contain ${
                      currentPlatform === item && "grayscale-0"
                    }`}
                    src={`${COMMON_WEB_PATH}/platformIcon/${item}.png`}
                    alt={item}
                  />
                </div>
              </SplideSlide>
            );
          })}
        </Splide>
      </div>
    </>
  );
};

export default SupplierList;
